import { formationOffsets, type FormationShape } from '../../shared/game/formation.js';

const cache = new Map<FormationShape, string>();

/**
 * A shape's glyph for the bronze bar: five bodies as dots in the shape they would take, the front toward the top, with a notch for
 * the way it faces. Drawn from the same layout the server uses, as a data URL the buttons read like any catalog glyph.
 */
export function formationGlyph(shape: FormationShape): string {
  let url = cache.get(shape);
  if (url) return url;
  const offsets = formationOffsets(shape, 5, 1), reach = Math.max(1.6, ...offsets.flatMap(offset => [Math.abs(offset.side), Math.abs(offset.ahead)]));
  const scale = 32 / reach, dots = offsets.map(offset => `<circle cx="${(50 + offset.side * scale).toFixed(1)}" cy="${(58 - offset.ahead * scale).toFixed(1)}" r="8"/>`).join('');
  url = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="#000" d="M50 2 63 17H37Z"/><g fill="#000">${dots}</g></svg>`)}`;
  cache.set(shape, url);
  return url;
}
